import { Question } from './question.js';
import { arrowIconSvg, arrowIconUpSvg, dragIconSvg } from '../icons/icons.js';
import { hexToRgba } from '../utils/color.js';

export class RankingQuestion extends Question {
    constructor(question, ctx) {
        super(question, ctx);
        this.rankingTextArray = [];
        this.question.answers.forEach((answer) => {
            this.rankingTextArray.push(answer.content);
        });
    }

    renderContent() {
        this.ctx.elementIds.push('answerOptionsElement' + this.question.id);
        let questionAnswers = [];
        let temp = [...this.question.answers];

        let answerOptions = document.createElement('div');
        answerOptions.style.marginTop = '16px';
        answerOptions.classList.add('ph-options');
        answerOptions.id = 'answerOptionsElement' + this.question.id;

        let rankingBlock = document.createElement('div');
        rankingBlock.classList.add('ph-ranking');
        rankingBlock.id = 'rankingBlock';
        rankingBlock.setAttribute('role', 'group');
        rankingBlock.setAttribute('aria-labelledby', 'ph-title-' + this.question.id);
        this.rankingContainer = rankingBlock;
        answerOptions.appendChild(rankingBlock);

        questionAnswers = this.ctx.changeAnswerOptionsSequence(temp, this.question.randomType);

        if (questionAnswers.length > 6) {
            rankingBlock.style.padding = '0 12px 0px 0px';
        }

        let arrowIconColor = arrowIconSvg(this.style.textColor);
        let arrowIconUpColor = arrowIconUpSvg(this.style.textColor);

        const updateSequence = (newAnswers) => {
            newAnswers.forEach((ans, idx) => {
                const el = this.ctx.getById(this.shadowRoot, 'rankingElementText' + idx);
                if (el) {
                    const textDiv = el.querySelector('div');
                    if (textDiv) textDiv.textContent = ans.content;
                }
            });
            questionAnswers = newAnswers;
            this.rankingTextArray = questionAnswers.map((q) => q.content);
            this.ctx.updateAnswers(this.question, this.rankingTextArray);
        };

        questionAnswers.forEach((answer, index) => {
            let rankingElement = document.createElement('div');
            rankingElement.id = 'rankingDragElement' + index;
            rankingElement.classList.add('ph-ranking__item');
            rankingElement.draggable = true;

            rankingElement.addEventListener('dragstart', (e) => {
                e.dataTransfer.setData('text/plain', index);
                rankingElement.classList.add('ph-ranking__item--dragging');
                // Ensure the drag image is the element itself
                e.dataTransfer.effectAllowed = 'move';
            });

            rankingElement.addEventListener('dragover', (e) => {
                e.preventDefault();
                e.dataTransfer.dropEffect = 'move';
                rankingElement.classList.add('ph-ranking__item--drag-over');
            });

            rankingElement.addEventListener('dragleave', () => {
                rankingElement.classList.remove('ph-ranking__item--drag-over');
            });

            rankingElement.addEventListener('drop', (e) => {
                e.preventDefault();
                rankingElement.classList.remove('ph-ranking__item--drag-over');
                const sourceIndex = parseInt(e.dataTransfer.getData('text/plain'));
                const targetIndex = index;

                if (sourceIndex !== targetIndex) {
                    const tempQuestionAnswers = [...questionAnswers];
                    const [moved] = tempQuestionAnswers.splice(sourceIndex, 1);
                    tempQuestionAnswers.splice(targetIndex, 0, moved);
                    updateSequence(tempQuestionAnswers);
                }
            });

            rankingElement.addEventListener('dragend', () => {
                rankingElement.classList.remove('ph-ranking__item--dragging');
            });

            let rankingElement_number = document.createElement('div');
            rankingElement_number.classList.add('ph-ranking__number-block');
            rankingElement_number.id = 'rankingElementNumberBlock' + index;
            let content = document.createElement('div');
            content.classList.add('ph-center');
            content.style.gap = '8px';
            let number = document.createElement('div');
            number.classList.add('ph-ranking__number');
            number.innerHTML = index + 1;
            let icon = document.createElement('div');
            icon.classList.add('ph-ranking__icon');
            icon.innerHTML = arrowIconColor;

            content.appendChild(number);
            content.appendChild(icon);
            rankingElement_number.appendChild(content);
            rankingElement_number.id = 'rankingElementNumber' + index;
            rankingElement_number.classList.add('ph-ranking__number-block');
            rankingElement.appendChild(rankingElement_number);

            let dropdown = document.createElement('div');
            dropdown.classList.add('ph-ranking__dropdown');
            dropdown.style.display = 'none';
            dropdown.id = 'rankingElementDropdown' + index;
            rankingElement_number.appendChild(dropdown);

            rankingElement_number.setAttribute('role', 'button');
            rankingElement_number.setAttribute('tabindex', '0');
            rankingElement_number.setAttribute('aria-haspopup', 'listbox');
            rankingElement_number.setAttribute('aria-expanded', 'false');
            rankingElement_number.addEventListener('keydown', (e) => {
                if (e.target !== rankingElement_number) return;
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    rankingElement_number.click();
                }
            });

            rankingElement_number.addEventListener('click', (e) => {
                e.stopPropagation();
                dropdown.style.display = dropdown.style.display === 'none' ? 'flex' : 'none';
                rankingElement_number.setAttribute('aria-expanded', dropdown.style.display !== 'none' ? 'true' : 'false');
                rankingElement_number.style.borderBottom = dropdown.style.display === 'none' ? '1px solid ' + hexToRgba(this.style.textColor, 0.32) : 'none';
                rankingElement_number.style.borderBottomLeftRadius = dropdown.style.display === 'none' ? '4px' : '0px';
                rankingElement_number.style.borderBottomRightRadius = dropdown.style.display === 'none' ? '4px' : '0px';
                icon.innerHTML = dropdown.style.display === 'none' ? arrowIconColor : arrowIconUpColor;

                let allRankingDropdowns = this.shadowRoot.querySelectorAll('div[id^="rankingElementDropdown"]');
                let allRankingNumberBlocks = this.shadowRoot.querySelectorAll('div[id^="rankingElementNumber"]');
                let allRankingIcons = this.shadowRoot.querySelectorAll('.ph-ranking__icon');

                allRankingDropdowns.forEach((otherDropdown, otherIndex) => {
                    if (otherDropdown.id !== dropdown.id) {
                        otherDropdown.style.display = 'none';
                        allRankingNumberBlocks[otherIndex].style.borderBottom = '1px solid ' + hexToRgba(this.style.textColor, 0.32);
                        allRankingNumberBlocks[otherIndex].style.borderBottomLeftRadius = '4px';
                        allRankingNumberBlocks[otherIndex].style.borderBottomRightRadius = '4px';
                        allRankingIcons[otherIndex].innerHTML = arrowIconColor;
                    }
                });

                if (dropdown.style.display !== 'none') {
                    requestAnimationFrame(() => {
                        dropdown.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    });
                }
            });

            questionAnswers.forEach((answer, i) => {
                if (i === index) return;
                let option = document.createElement('div');
                option.classList.add('ph-ranking__number');
                option.style.cursor = 'pointer';
                option.style.padding = '0px 8px 8px 8px';
                option.style.textAlign = 'left';

                option.setAttribute('role', 'option');
                option.setAttribute('tabindex', '0');
                option.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        option.click();
                    }
                });
                option.textContent = i + 1;
                option.addEventListener('click', (e) => {
                    e.stopPropagation();
                    let rankingElementNumberBlock = this.ctx.getById(this.shadowRoot, 'rankingElementNumber' + index);
                    dropdown.style.display = 'none';

                    rankingElementNumberBlock.style.borderBottom = '1px solid ' + hexToRgba(this.style.textColor, 0.32);
                    rankingElementNumberBlock.style.borderBottomLeftRadius = '4px';
                    rankingElementNumberBlock.style.borderBottomRightRadius = '4px';
                    icon.innerHTML = dropdown.style.display === 'none' ? arrowIconColor : arrowIconUpColor;

                    const tempQuestionAnswers = [...questionAnswers];
                    const [moved] = tempQuestionAnswers.splice(index, 1);
                    tempQuestionAnswers.splice(i, 0, moved);
                    updateSequence(tempQuestionAnswers);
                });
                dropdown.appendChild(option);
            });

            let rankingElement_text = document.createElement('div');
            rankingElement_text.classList.add('ph-ranking__text');
            rankingElement_text.innerHTML = `<div>${answer.content}</div>`;
            rankingElement_text.id = 'rankingElementText' + index;

            let dragIcon = document.createElement('div');
            dragIcon.classList.add('ph-ranking__drag-icon');
            dragIcon.innerHTML = dragIconSvg(this.style.textColor);
            rankingElement_text.appendChild(dragIcon);

            rankingElement.appendChild(rankingElement_text);
            rankingBlock.appendChild(rankingElement);
        });

        return answerOptions;
    }

    renderNextButton() {
        let nextButton = document.createElement('button');
        nextButton.classList.add('ph-btn--primary');
        nextButton.textContent = this.question.buttonName;
        nextButton.addEventListener('click', () => {
            if (this.rankingTextArray.length === 0) {
                let errorElement = this.ctx.getById(this.shadowRoot, 'errorElement' + this.question.id);
                errorElement.classList.add('ph-error');
                errorElement.textContent = this.question.errorText;
                this.setAriaInvalid(this.rankingContainer);
            } else {
                this.clearAriaInvalid(this.rankingContainer);
                this.ctx.goNext(this.question, this.rankingTextArray);
            }
        });
        return nextButton;
    }
}
